/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT,
  LOGOUT_EXPIRED_SESSION,
  SILENT_LOGIN,
  UPDATE_PROFILE,
} from 'src/store/actions/accountActions';

const initialState = {
  user: null,
  isAuthorized: false,
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST: {
      return produce(state, (draft) => {
        // Ensure we clear current session
        draft.user = null;
        draft.isAuthorized = false;
      });
    }

    case LOGIN_SUCCESS: {
      const { user } = action.payload;

      return produce(state, (draft) => {
        draft.isAuthorized = true;
        draft.user = user;
      });
    }

    case LOGIN_FAILURE: {
      return produce(state, () => {
        // Maybe store error
      });
    }

    case LOGOUT: {
      return produce(state, (draft) => {
        draft.user = null;
        draft.isAuthorized = false;
      });
    }

    case LOGOUT_EXPIRED_SESSION: {
      return produce(state, (draft) => {
        draft.isAuthorized = false;
        draft.user = null;
      });
    }

    case SILENT_LOGIN: {
      const { user } = action.payload;

      return produce(state, (draft) => {
        draft.user = user;
        draft.isAuthorized = true;
      });
    }

    case UPDATE_PROFILE: {
      const { user } = action.payload;

      return produce(state, (draft) => {
        draft.user = user;
        draft.isAuthorized = true;
      });
    }

    default: {
      return state;
    }
  }
};

export default accountReducer;
